import apiService from "./apiService";

const transactionService = {
    async applyAdjustment(transaction) {
        try {
            const resp = await apiService.post(`transactions/add`, transaction, true);
            return resp.data;
        }
        catch {
            return { code: -1, message: 'An error occured while processing the request!' };
        }
    },
    async deleteBill(id) {
        try {
            const resp = await apiService.delete(`transactions/${id}/delete-bill`, true);
            return resp.data;
        }
        catch {
            return { code: -1, message: "An error occured while processing the request." }
        }
    },
    async searchCashflows(page, rp, searchModel) {
        try {
            const resp = await apiService.get(`transactions/${page}/${rp}/search-cashflow`, searchModel, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async searchReceipts(page, rp, searchModel) {
        try {
            const resp = await apiService.get(`transactions/${page}/${rp}/search-receipt`, searchModel, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async searchRemittances(page, rp, searchModel) {
        try {
            const resp = await apiService.get(`transactions/${page}/${rp}/search-remittances`, searchModel, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async acceptRemittance(remittance) {
        try {
            const resp = await apiService.post(`transactions/accept-remittance`, remittance, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async deleteRemittance(id) {
        try {
            const resp = await apiService.delete(`transactions/${id}/delete-remittance`, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
}

export default transactionService;